/**
 * Special icon for indicating status - used in forms and grids typically
 * simply pass active={true/false}
 */
import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Icon } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const StatusIcon = props => {
  const { active, color, ...rest } = props // eslint-disable-line
  const newColor = active ? 'success' : 'error'
  return (
    <Icon
      color={newColor}
      name='circle'
      className={cx('status-icon')}
      {...rest}
    />
  )
}

StatusIcon.propTypes = {
  ..._.omit(Icon.propTypes, 'name'),
  active: PropTypes.bool,
}

export default StatusIcon
